import React from "react";
import "../styles/components/SectionTerms.css";
const Parser = require("html-react-parser");

const SectionsTerms = elements => {
  return (
    <ul className="container container-small section-terms">
      {elements.elements.length > 0 &&
        elements.elements.map((item, idx) => {
          return (
            <li className="row" key={idx}>
              <div className="col-12">
                <h4>
                  <span>{idx + 1 <= 9 ? `0${idx + 1}` : idx + 1}.</span>
                  {item.tytul_naglowka}
                </h4>
                {Parser(item.tresc_naglowka)}
              </div>
            </li>
          );
        })}
    </ul>
  );
};

export default SectionsTerms;
